import { render, staticRenderFns } from "./MoveVerticalDivider.vue?vue&type=template&id=38f400be&"
import script from "./MoveVerticalDivider.vue?vue&type=script&lang=js&"
export * from "./MoveVerticalDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports